<template>
  <div class="page">
    <div class="top_bg"></div>
    <div class="container">
      <div class="container_bg">
        <div class="card card1">
          <div class="box">
            <div class="top">
              <div class="avator">
                <img :src="publicData.accountBasic.shareLogo" alt="">
              </div>
              <div class="name">{{publicData.name}}</div>
            </div>
            <div class="mid">
              <div class="mid-item">
                <div class="mid-item-left">
                  <img src="./assets/img/yue@2x.png" alt="" />
                </div>
                <div class="mid-item-right">
                  <div class="mid-item-right-top">
                    <span>账户余额</span>
                  </div>
                  <div class="mid-item-right-bot">
                    <span>¥{{baseInfo.amount}}</span>
                  </div>
                </div>
              </div>
              <div class="mid-item">
                <div class="mid-item-left">
                  <img src="./assets/img/jif@2x.png" alt="" />
                </div>
                <div class="mid-item-right">
                  <div class="mid-item-right-top">
                    <span>推广费</span>
                  </div>
                  <div class="mid-item-right-bot">
                    <span>¥{{baseInfo.reback ? baseInfo.reback : publicData.accountBasic.reback}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="bot">
              <div class="btn" @click="recharge()">充值</div>
            </div>
          </div>
        </div>
        <div class="card card2">
          <div class="item" @click="gotoOrder()">
            <div class="top">
              <img src="./assets/img/baod@2x.png" alt="" />
            </div>
            <div class="name">我的保单</div>
          </div>
          <div class="item" @click="gotoClaim()">
            <div class="top">
              <img src="./assets/img/lip@2x.png" alt="" />
            </div>
            <div class="name">我要理赔</div>
          </div>
          <div class="item" @click="gotoFengXian()">
            <div class="top">
              <img src="./assets/img/guw@2x.png" alt="" />
            </div>
            <div class="name">风险顾问</div>
          </div>
          <div class="item" @click="gotoCollect()">
            <div class="top">
              <img src="./assets/img/shouc@2x.png" alt="" />
            </div>
            <div class="name">我的收藏</div>
          </div>
        </div>
        <div class="card card3">
          <div class="title">更多服务</div>
          <!-- 修改密码 -->
          <div class="item">
            <div class="item-left">
              <img src="./assets/img/mingd@2x.png" alt="" />
            </div>
            <div class="item-mid"  is-link @click="showPopup">修改密码</div>
            <div class="item-right">
              <img src="./assets/img/jiant@2x.png" alt="" />
            </div>
            <van-popup v-model="show" style="width:330px;height:350px">
                <div style="font-size:24px;text-align:center;padding:10px">修改密码</div>
                <van-form style="height:290px">
                  <van-field
                    v-model="pass"
                    type="password"
                    name="新密码"
                    label="新密码"
                    placeholder="请输入密码"
                    :rules="[{ required: true,trigger: 'onBlur', message: '密码不能为空' },
                    {pattern,trigger: 'onBlur',message: '密码必须包含数字、字母、特殊字符，且最小密码长度为8'}
                    ]"
                  />
                  <van-field
                    v-model="checkPass"
                    type="password"
                    name="确认密码"
                    label="确认密码"
                    placeholder="请输入密码"
                    :rules="[{ required: true, message: '密码不能为空' },{pattern,message: '密码必须包含数字、字母、特殊字符，且最小密码长度为8'}]"
                  />
                  <button round block type="info" style="width:280px;height:55px;font-size:18px;position:relative;bottom:2px;left:25px;border-radius:30px;border:none;color:white;background-color:#0099ff" @click="onSubmit">提交</button>
                </van-form>
            </van-popup>
          </div>
          <div class="item" @click="gotoNameList()">
            <div class="item-left">
              <img src="./assets/img/mingd@2x.png" alt="" />
            </div>
            <div class="item-mid">收集名单</div>
            <div class="item-right">
              <img src="./assets/img/jiant@2x.png" alt="" />
            </div>
          </div>
          <!-- <div class="item">
            <div class="item-left">
              <img src="./assets/img/fengx@2x.png" alt="" />
            </div>
            <div class="item-mid">风险合伙人计划</div>
            <div class="item-right">
              <img src="./assets/img/jiant@2x.png" alt="" />
            </div>
          </div> -->
          <div class="item" @click="gotoYanJiu()">
            <div class="item-left">
              <img src="./assets/img/yanj@2x.png" alt="" />
            </div>
            <div class="item-mid">风险研究院</div>
            <div class="item-right">
              <img src="./assets/img/jiant@2x.png" alt="" />
            </div>
          </div>
          <!-- <div class="item">
            <div class="item-left">
              <img src="./assets/img/about@2x.png" alt="" />
            </div>
            <div class="item-mid">关于希望保</div>
            <div class="item-right">
              <img src="./assets/img/jiant@2x.png" alt="" />
            </div>
          </div> -->

        </div>
        <div class="logout" @click="logOut()">退出</div>
      </div>
    </div>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import { Dialog,Popup,Form,Field,Toast } from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";

export default {
  name: "Mine",
  components: { Dialog,Popup,Form,Field, [Toast.name]: Toast, },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData"),
      baseInfo:{},
      show: false,
      pass:'',
      checkPass:'',
      pattern:/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/

    };
  },
  watch: {},
  mounted() {
      this.publicData = this.$store.state.d2admin.user.info
      document.title = '个人中心'
      this.getAcount()
  },
  beforeDestroy: function () {},
  methods: {
    validator(val) {
      return /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/.test(val);
    },
     showPopup() {
      this.show = true;
    },
    async onSubmit() {
      let reg=/^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,30}$/;
        if(this.pass=='' && this.checkPass == ''){
          Toast.fail('请输入密码')
          // Toast.success('成功文案');
          // this.$message.error('请输入密码')
          return
        }else if(!reg.test(this.pass)){
          Toast.fail('密码必须包含数字、字母、特殊字符，且最小密码长度为8')
          //  this.$message.error('密码必须包含数字、字母、特殊字符，且最小密码长度为8')
          return
        }else if(!reg.test(this.checkPass)){
          Toast.fail('密码必须包含数字、字母、特殊字符，且最小密码长度为8')
          //  this.$message.error('密码必须包含数字、字母、特殊字符，且最小密码长度为8')
          return
        }else if(this.pass!==this.checkPass){
          Toast.fail('两次密码输入不一致')
          // this.$message.error('两次密码输入不一致')
          return
        }else{
          let res = await this.$http.post("/api/accountLogin/update",{
              phone:this.publicData.mobile,
              // pass:this.ruleFormPwd.pass,
              pwd:this.checkPass
            })
            if(!res.code){
                this.getAcount()
                Toast.success('密码修改成功！');
                // this.$message.success('密码修改成功！')
                this.show = false;
                this.$refs.resetFields()
            }else{
              Toast.fail('密码修改失败！')
                // this.$message.success('密码修改失败！')
                this.getAcount()
            }
        }   
      console.log('submit', values);
    },
    async getAcount(){
      let res = await this.$http.post("/api/accountLogin/getAccountMoney")
      if(res.code == 0){
        this.baseInfo = res.t
      }else{
        this.$message.error(res.msg);
      }
    },
    // async getAcount(){
    //     // accountLogin/getAccountBasic
    //     let res = await this.$http.post("/api/accountLogin/getAccountBasic", {
    //         companyId:this.publicData.companyId,
    //         accountId:this.publicData.id
    //     });
    //     if(!res.code){
    //         console.log('publicData',this.publicData)
    //         this.publicData.accountBasic = res.t
    //         this.$store.dispatch('d2admin/user/set', this.publicData, { root: true })
    //         this.baseInfo = this.publicData.accountBasic
    //         //设置用户所有信息
    //         storejs.set("publicData", this.publicData);
    //         // console.log('res',res) 
    //     }
        
    // },
    async recharge(){
        this.$router.push({
            name:'Recharge'
        })
    },
    gotoCollect(){
        this.$router.push({
            name:'Collect'
        })
    },
    gotoOrder(){
        this.$router.push({
            name:'OrderList'
        })
    },
    gotoClaim(){
        this.$router.push({
            name:'Claim'
        })
    },
    gotoFengXian(){
        this.$router.push({
            name:'FengXian'
        })
    },
    gotoNameList(){
        this.$router.push({
            name:'NameList'
        })
    },
    gotoYanJiu(){
        this.$router.push({
            name:'YanJiu'
        })
    },
    logOut() {
        Dialog.confirm({
        title: '提示',
        message: '您确定要退出当前账号吗？',
        })
        .then(() => {
            // 删除cookie
            util.cookies.remove("token");
            util.cookies.remove("uuid");
            //删除用户信息
            storejs.set("permissions", []);
            //删除所有信息
            storejs.set("publicData", {});
            // 跳转路由
            localStorage.clear();
            this.$router.push({
                name: "Login",
            });
        })
        .catch(() => {
            // on cancel
        });
      
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .top_bg {
    background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
    width: 100%;
    height: 1.65rem;
  }
  .container {
    height: auto;
    width: 100%;
    background: #fff;
    padding: 15px;
    box-sizing: border-box;
    position: relative;
    padding-bottom: 0.3rem;
    .container_bg {
      position: absolute;
      top: -1rem;
      .card {
        width: 3.45rem;

        background: #ffffff;

        box-shadow: 0px -4px 5px 0px rgba(0, 26, 17, 0.06),
          0px 4px 5px 0px rgba(0, 26, 17, 0.06);

        border-radius: 8px;
        &.card1 {
          height: 2.12rem;
          .box {
            width: 100%;
            height: 100%;
            position: relative;
            .top {
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
              position: absolute;
              top: -13%;
              width: 100%;
              .avator {
                width: 0.58rem;
                height: 0.58rem;
                border-radius: 50%;
                // background: blue;
                display: flex;

                img {
                  width: 0.58rem;
                  height: 0.58rem;
                  border-radius: 50%;
                }
              }
              .name {
                height: 0.14rem;
                font-size: 0.15rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #333333;
                margin-top: 0.16rem;
              }
            }
            .mid {
              display: flex;
              justify-content: space-between;
              height: 0.4rem;
              position: absolute;
              width: 100%;
              top: 40%;
              .mid-item {
                width: 50%;
                display: flex;
                justify-content: center;
                .mid-item-left {
                  width: 0.35rem;
                  height: 0.28rem;
                  flex-shrink: 0;
                  display: flex;
                  img {
                    width: 0.35rem;
                    height: 0.28rem;
                  }
                }
                .mid-item-right {
                  display: flex;
                  flex-direction: column;
                  padding-left: 10px;
                  height: 0.28rem;
                  justify-content: space-between;

                  .mid-item-right-top {
                    height: 0.1rem;
                    display: flex;
                    span {
                      font-size: 0.1rem;
                      font-family: Adobe Heiti Std;
                      font-weight: normal;
                      color: #888888;
                      //   line-height: 0.36rem;
                    }
                  }
                  .mid-item-right-bot {
                    height: 0.15rem;
                    display: flex;
                    span {
                      font-size: 0.15rem;
                      font-family: PingFang SC;
                      font-weight: 500;
                      color: #333333;
                      //   line-height: 0.36rem;
                    }
                  }
                }
              }
            }
            .bot {
              position: absolute;
              width: 100%;
              top: 70%;
              display: flex;
              justify-content: center;
              .btn {
                width: 3.25rem;
                height: 0.42rem;
                background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);

                border-radius: 21px;
                display: flex;
                justify-content: center;
                align-items: center;

                font-size: 0.12rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #ffffff;
                line-height: 0.36rem;
              }
            }
          }
        }
        &.card2 {
          display: flex;
          padding: 0.3rem 0;
          margin-top: 0.11rem;

          .item {
            width: 25%;
            display: flex;
            flex-direction: column;
            align-items: center;
            // height: ;
            .top {
              width: 0.28rem;
              height: 0.28rem;
              display: flex;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .name {
              margin-top: 0.12rem;
              height: 0.13rem;
              font-size: 0.13rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
            }
          }
        }
        &.card3 {
          padding: 0.2rem 0.15rem;
          margin-top: 0.11rem;
          box-sizing: border-box;
          padding-bottom: 0.09rem;
          .title {
            font-size: 0.17rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }
          .item {
            display: flex;
            align-items: center;
            padding-top: 0.19rem;
            padding-bottom: 0.19rem;
            .item-left {
              width: 0.17rem;
              height: 0.17rem;
              display: flex;
              flex-shrink: 0;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .item-mid {
              margin-left: 0.14rem;
              font-size: 0.13rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              flex: 1;
            }
            .item-right {
              width: 0.08rem;
              height: 0.12rem;
              display: flex;
              margin-left: auto;
              flex-shrink: 0;
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
      .logout {
        width: 3.45rem;
        margin-top: 0.21rem;
        margin-bottom: 0.3rem;

        height: 0.45rem;
        border: 1px solid #2dd97a;
        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #2dd97a;

        border-radius: 12px;
      }
    }
  }
}
</style>